import request from '@/utils/http';
const apiCrmHost = 'api-lcrm';

// 客户负责人归档列表查询
export const getCustomerManagerArchivePage = (data) => {
    return request({
        url: apiCrmHost + '/customer/manager/archive/page',
        method: 'post',
        data
    });
};
// 客户负责人归档信息保存
export const customerManagerArchiveSave = (data) => {
    return request({
        url: apiCrmHost + '/customer/manager/archive/save',
        method: 'post',
        data
    });
};
// 客户负责人归档信息删除
export const customerManagerArchiveRemove = (data) => {
    return request({
        url: apiCrmHost + '/customer/manager/archive/remove',
        method: 'DELETE',
        data
    });
};
// 客户负责人归档信息-控权
export const getCustomerArchiveReport = (data) => {
    return request({
        url: apiCrmHost + '/customer/manager/archive/report',
        method: 'post',
        data
    });
};
// 客户负责人归档信息-转移-rzq
export const customerArchiveTransfer = (data) => {
    return request({
        url: apiCrmHost + '/customer/manager/archive/transfer',
        method: 'post',
        data
    });
};
